/**
 * Document file fields (type "file") — aligned with back/utils/documentUploadMime.js
 * and POST /api/upload/upload. Image fields (type "image") use upload-public separately.
 *
 * Default accept = documents + common images (JPG/PNG/GIF/WebP).
 */

/** Value for `<input type="file" accept="...">` on document fields */
export const DOCUMENT_FILE_INPUT_ACCEPT =
  "application/pdf,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,image/jpeg,image/png,image/gif,image/webp,.jpg,.jpeg,.png,.gif,.webp";

export const DOCUMENT_UPLOAD_MIME_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
];

/** Match multer limits in uploadRoutes.js */
export const DOCUMENT_UPLOAD_MAX_BYTES = 20 * 1024 * 1024;

/**
 * @param {File} file
 * @returns {boolean}
 */
export function isDocumentUploadAllowed(file) {
  if (!file) return false;

  if (DOCUMENT_UPLOAD_MIME_TYPES.includes(file.type)) return true;
  if (String(file.type || "").startsWith("image/")) return true;

  const name = (file.name || "").toLowerCase();
  if (
    name.endsWith(".pdf") ||
    name.endsWith(".doc") ||
    name.endsWith(".docx") ||
    name.endsWith(".xls") ||
    name.endsWith(".xlsx") ||
    /\.(jpe?g|png|gif|webp)$/i.test(name)
  ) {
    return true;
  }

  if (file.type === "application/octet-stream") {
    return /\.(pdf|docx?|xlsx?|jpe?g|png|gif|webp)$/i.test(name);
  }

  return false;
}

/**
 * @param {string | undefined | null} fieldAccept
 * @returns {string}
 */
export function resolveDocumentFieldAccept(fieldAccept) {
  const custom = String(fieldAccept || "").trim();
  if (custom && custom !== "*") return custom;
  return DOCUMENT_FILE_INPUT_ACCEPT;
}
